<template>
  <div id="shipments">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 mt-1">
      <div class="d-flex px-5 justify-space-between align-center">
        <h1>Lista de importação de dados do embarque</h1>
        <v-btn elevation="2" color="success" large @click="filesDialog = true"> CARREGAR PLANILHAS </v-btn>
      </div>

      <div class="mt15"></div>

      <shipment-import-filters :loadingGetAll="loading" @filterSearch="filterSearch" />

      <div class="table mt-10">
        <v-data-table
          :headers="headers"
          :items="getShipments"
          :loading="loading"
          :items-per-page="paginate.pageSize"
          @update:items-per-page="changeItemsPerPage"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 50],
            itemsPerPageText: 'Itens por página'
          }"
        >
          <template v-slot:[`item.disabled`]="{ item, index }">
            <v-switch
              v-model="item.disabled"
              :false-value="true"
              :true-value="false"
              inset
              color="success"
              readonly
              @click.stop.prevent="openDialogStatus(item, index)"
            ></v-switch>
          </template>

          <template v-slot:[`item.createdAt`]="{ item }">
            {{ transformImportDate(item.createdAt) }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex" v-if="isDetailsValid(item.status)">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <ViewSVG @click="openProcessing(item)" v-bind="attrs" v-on="on" />
                </template>
                <span>Detalhes</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
      </div>
    </v-card>

    <v-dialog v-model="filesDialog" persistent max-width="700">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <h1>Selecione sua planilha</h1>
            <v-btn icon @click="filesDialog = false" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="mt30"></div>
          <v-file-input
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :label="file ? 'Planilha Selecionada: ' : 'Selecione a planilha'"
            @change="onChange"
          ></v-file-input>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" large @click="filesDialog = false"> Cancelar </v-btn>
          <v-btn color="success" class="flex-grow-1" large @click="closeAndOpen()" :disabled="file === null">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="mt15"></div>

    <v-dialog v-model="validSheet" persistent>
      <v-card class="align-center text-center">
        <v-card-text>
          <h1 class="pt-10 text-left">Valide os dados da planilha</h1>
          <div class="mt30"></div>
          <v-row justify="space-between">
            <v-col cols="12" md="10">
              <v-tabs v-model="tab">
                <v-tabs-slider color="blue"></v-tabs-slider>
                <v-tab v-for="item in items" :key="item">
                  {{ item }}
                </v-tab>
              </v-tabs>
            </v-col>
            <v-col cols="12" md="2" class="d-flex pb-7 justify-end">
              <v-btn color="error" large @click="validSheet = false"> Cancelar </v-btn>
              <v-btn
                color="info"
                class="ml-3"
                large
                :loading="loadingCreate"
                @click="sendSheed"
                :disabled="!checkValidSheetForm()"
              >
                Processar Planilha
              </v-btn>
            </v-col>
          </v-row>

          <section class="border-tab" v-show="!tab">
            <v-row>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="directDelivererId"
                  :items="getSummaryData"
                  label="Motorista"
                  item-text="name"
                  item-value="id"
                  @change="selectedDeliverer"
                  class="auto-complete"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field disabled v-model="vehiclePlate" label="Placa veículo"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="freightPrice" label="Preço da Viagem" v-money="money"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="totalMileage" label="Quilometragem total" v-mask="maskNumber"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field disabled v-model="dateCreate" label="Data de Criação"></v-text-field>
              </v-col>
            </v-row>
          </section>
          <section
            class="border-tab scroll no-border"
            :style="{ height: '520px', width: 'auto' }"
            style="overflow-x: scroll"
            v-show="tab"
          >
            <xlsx-read :file="file">
              <xlsx-table :sheet="0" />
            </xlsx-read>
          </section>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isProcessing" persistent>
      <v-card class="align-center text-center" :loading="loadingShipment" style="overflow-y: scroll">
        <v-card-text>
          <div class="close-right" @click="isProcessing = false" role="button">
            <v-icon>mdi-close</v-icon>
          </div>
          <h1 class="pt-10 text-left">
            {{ !itemImportStatusProcessing && !itemImportStatusError ? 'Confirmar dados do embarque' : 'Dados gerais' }}
          </h1>
          <div class="mt30"></div>
          <v-row justify="space-between">
            <v-col cols="12" md="10">
              <v-tabs v-model="tabProcessing">
                <v-tabs-slider color="blue"></v-tabs-slider>

                <v-tab v-for="item in itemsProcessing" :key="item">
                  {{ item }}
                </v-tab>
                <v-tab v-if="!itemImportStatusProcessing && !itemImportStatusError">Financeiro</v-tab>
              </v-tabs>
            </v-col>
            <v-col cols="12" md="2" class="d-flex pb-7 justify-end">
              <v-btn
                v-if="itemImportStatusProcessing || itemImportStatusError"
                color="error"
                large
                @click="isProcessing = false"
              >
                Fechar
              </v-btn>
              <v-btn v-else color="error" :loading="loadingCreate" large @click="approveSheet(false)">
                Descartar Planilha
              </v-btn>
              <v-tooltip
                v-if="!itemImportStatusProcessing && !itemImportStatusError"
                top
                :disabled="hasValidFinancialData"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex w-100" v-bind="attrs" v-on="on">
                    <v-btn
                      color="info"
                      class="ml-3"
                      large
                      :loading="loadingCreate"
                      :disabled="!hasValidFinancialData"
                      @click="approveSheet()"
                    >
                      Importar dados
                    </v-btn>
                  </div>
                </template>
                <span> Previsão de pagamento obrigatória para adiantamento ou adicionais </span>
              </v-tooltip>
            </v-col>
          </v-row>

          <section class="border-tab" v-show="tabProcessing === 0">
            <v-row v-if="itemProcessing != null">
              <v-col cols="12" md="3">
                <v-text-field v-model="itemProcessing.directDelivererName" disabled label="Motorista"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field disabled v-model="itemProcessing.plateVehicle" label="Placa veículo"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  disabled
                  v-model="itemProcessing.freightPrice"
                  label="Preço da Viagem"
                  v-money="money"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  disabled
                  v-model="itemProcessing.totalMileage"
                  label="Quilometragem total"
                  v-mask="maskNumber"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field disabled v-model="formattedCreatedAt" label="Data de Criação"></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="!itemImportStatusProcessing && !itemImportStatusError">
              <v-col cols="12" md="12"><div class="mt5"></div></v-col>
              <v-col cols="12" md>
                <div class="bg-azul-soma">
                  <img :src="t1" />
                  <div>
                    <div class="title-box">TRANSFERÊNCIAS</div>
                    <div class="text-box">{{ transfer }}</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md>
                <div class="bg-azul-soma">
                  <img :src="t2" />
                  <div>
                    <div class="title-box">CARGAS</div>
                    <div class="text-box">{{ loads }}</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md>
                <div class="bg-azul-soma">
                  <img :src="t3" />
                  <div>
                    <div class="title-box">PARADAS</div>
                    <div class="text-box">{{ stops }}</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md>
                <div class="bg-azul-soma">
                  <img :src="t4" />
                  <div>
                    <div class="title-box">ENTREGAS</div>
                    <div class="text-box">{{ deliveries }}</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md>
                <div class="bg-azul-soma">
                  <img :src="t5" />
                  <div>
                    <div class="title-box">NOTAS FISCAIS</div>
                    <div class="text-box">{{ nfe }}</div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </section>
          <section
            class="border-tab scroll no-border"
            v-show="tabProcessing === 1 && (itemImportStatusError || itemImportStatusProcessing)"
          >
            <div v-if="itemImportStatusError && itemProcessing != null">
              <div class="mt"></div>
              <table class="w-100">
                <thead>
                  <tr>
                    <th>Linha</th>
                    <th>Erros</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-left" v-for="errorsItem of itemProcessing.errorsJson" :key="errorsItem.line">
                    <td class="text-left">Linha {{ errorsItem.line }}</td>
                    <td class="pt-5">
                      <p v-for="error in errorsItem.errors" :key="error">
                        {{ error }}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p v-else>A tabela está sendo processada. Aguarde!</p>
          </section>
          <section
            class="border-tab scroll no-border"
            :style="{ height: '520px', width: 'auto' }"
            v-show="tabProcessing === 1 && !itemImportStatusProcessing && !itemImportStatusError"
          >
            <v-row style="margin: 0">
              <v-col
                class="title-table"
                cols="12"
                md
                v-for="(col, indexStop) in columnsStopOptions"
                :key="col.text + indexStop"
                >{{ col.text }}</v-col
              >
            </v-row>
            <template v-for="(node, nodeIndex) in nodesDirect">
              <div :key="node.data.id + nodeIndex">
                <v-row class="text-table" :class="nodeIndex % 2 !== 0 ? 'off' : ''">
                  <v-col
                    class="no-padding"
                    style="display: flex; align-items: flex-start"
                    cols="12"
                    md
                    v-for="(column, index) in columnsStops"
                    :key="column + index"
                  >
                    <span v-if="index === 0" @click="onExpand(node)">
                      <v-icon v-if="node.open"> mdi-chevron-down </v-icon>
                      <v-icon v-else> mdi-chevron-right </v-icon>
                    </span>
                    <span v-if="column === 'stopStatus'">
                      <span v-for="sticks in node.data[column]" :key="sticks.name">
                        <v-chip color="info">
                          {{ sticks.name }}
                        </v-chip>
                      </span>
                    </span>
                    <span v-else> {{ node.data[column] }}</span>
                  </v-col>
                </v-row>

                <v-row v-if="node.open" style="margin-top: 0">
                  <v-col cols="12">
                    <v-card>
                      <v-card-text class="p-5">
                        <v-row style="margin: 0">
                          <v-col
                            class="title-table"
                            cols="12"
                            md
                            v-for="(column, indexCol) in columnsDeliveriesOptions"
                            :key="column.text + indexCol"
                            >{{ column.text }}</v-col
                          >
                        </v-row>
                        <template v-for="(stop, stopIndex) in node.children">
                          <div :key="stop.data.id + stopIndex">
                            <v-row class="text-table" :class="stopIndex % 2 !== 0 ? 'off' : ''">
                              <v-col
                                class="no-padding"
                                style="display: flex; align-items: flex-start"
                                v-for="(columnDeliveries, columnDeliveriesIndex) in columnsDeliveries"
                                :key="columnDeliveries + columnDeliveriesIndex"
                              >
                                <span v-if="columnDeliveriesIndex === 0" @click="onExpand(stop)">
                                  <v-icon v-if="stop.open"> mdi-chevron-down </v-icon>
                                  <v-icon v-else> mdi-chevron-right </v-icon>
                                </span>

                                <span v-if="columnDeliveries === 'deliveryStatus'">
                                  <span v-for="sticks in stop.data[columnDeliveries]" :key="sticks.name">
                                    <v-chip color="info">
                                      {{ sticks.name }}
                                    </v-chip>
                                  </span>
                                </span>
                                <span v-else>
                                  {{ stop.data[columnDeliveries] }}
                                </span>
                              </v-col>
                            </v-row>
                            <v-row v-if="stop.open" style="margin-top: 0">
                              <v-col cols="12">
                                <v-card>
                                  <v-card-text class="p-5">
                                    <v-row style="margin: 0">
                                      <v-col
                                        class="title-table"
                                        cols="12"
                                        md
                                        v-for="(column, colIndex) in columnsNfeOptions"
                                        :key="column.text + colIndex"
                                        >{{ column.text }}</v-col
                                      >
                                    </v-row>
                                    <v-row
                                      v-for="(nfe, nfeIndex) in stop.children"
                                      :key="nfe.data.accessKey + nfeIndex"
                                      class="text-table"
                                      :class="nfeIndex % 2 !== 0 ? 'off' : ''"
                                    >
                                      <v-col
                                        class="no-padding"
                                        style="display: flex; align-items: flex-start"
                                        v-for="(columnNfe, indexNfe) in columnsNfe"
                                        :key="columnNfe + indexNfe"
                                      >
                                        <span>
                                          {{ nfe.data[columnNfe] }}
                                        </span>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                                <div class="mt20"></div>
                              </v-col>
                            </v-row>
                          </div>
                        </template>
                      </v-card-text>
                    </v-card>
                    <div class="mt20"></div>
                  </v-col>
                </v-row>
              </div>
            </template>
          </section>
          <section
            class="border-tab scroll no-border"
            :style="{ height: '520px', width: 'auto' }"
            v-show="tabProcessing === 2 && !itemImportStatusProcessing && !itemImportStatusError"
          >
            <v-row style="margin: 0">
              <v-col class="title-table" cols="12" md v-for="col in columnsTranshipmentOptions" :key="col.text">{{
                col.text
              }}</v-col>
            </v-row>
            <template v-for="(node, nodeIndex) in nodes">
              <div :key="node.data.id">
                <v-row class="text-table" :class="nodeIndex % 2 !== 0 ? 'off' : ''">
                  <v-col
                    class="no-padding"
                    style="display: flex; align-items: flex-start"
                    cols="12"
                    md
                    v-for="(column, index) in columnsTranshipment"
                    :key="column + 'transfer'"
                  >
                    <span v-if="index === 0" @click="onExpandNormal(node, node.key)">
                      <v-icon v-if="node.open"> mdi-chevron-down </v-icon>
                      <v-icon v-else> mdi-chevron-right </v-icon>
                    </span>
                    <span>
                      {{ node.data[column] }}
                    </span>
                  </v-col>
                </v-row>

                <v-row v-if="node.open" style="margin-top: 0">
                  <v-col cols="12">
                    <v-card>
                      <v-card-text class="p-5">
                        <v-row style="margin: 0">
                          <v-col
                            class="title-table"
                            cols="12"
                            md
                            v-for="column in columnsCargoOptions"
                            :key="column.text"
                            >{{ column.text }}</v-col
                          >
                        </v-row>
                        <template v-for="(cargo, cargoIndex) in node.children">
                          <div :key="cargo.data.id">
                            <v-row class="text-table" :class="cargoIndex % 2 !== 0 ? 'off' : ''">
                              <v-col
                                class="no-padding"
                                v-for="(columnCargo, columnCargoIndex) in columnsCargo"
                                :key="columnCargo"
                                cols="12"
                                md
                              >
                                <span v-if="columnCargoIndex === 0" @click="onExpandNormal(cargo, node.key)">
                                  <v-icon v-if="cargo.open"> mdi-chevron-down </v-icon>
                                  <v-icon v-else> mdi-chevron-right </v-icon>
                                </span>
                                <span>
                                  {{ cargo.data[columnCargo] }}
                                </span>
                              </v-col>
                            </v-row>

                            <v-row v-if="cargo.open" style="margin-top: 0">
                              <v-col cols="12">
                                <v-card>
                                  <v-card-text class="p-5">
                                    <v-row style="margin: 0">
                                      <v-col
                                        class="title-table"
                                        cols="12"
                                        md
                                        v-for="column in columnsStopOptions"
                                        :key="column.text"
                                        >{{ column.text }}</v-col
                                      >
                                    </v-row>
                                    <template v-for="(stop, stopIndex) in cargo.children">
                                      <div :key="stop.data.id">
                                        <v-row class="text-table" :class="stopIndex % 2 !== 0 ? 'off' : ''">
                                          <v-col
                                            class="no-padding"
                                            v-for="(columnStops, columnStopsIndex) in columnsStops"
                                            :key="columnStops"
                                            cols="12"
                                            md
                                          >
                                            <span v-if="columnStopsIndex === 0" @click="onExpandNormal(stop, node.key)">
                                              <v-icon v-if="stop.open"> mdi-chevron-down </v-icon>
                                              <v-icon v-else> mdi-chevron-right </v-icon>
                                            </span>

                                            <span>
                                              {{ stop.data[columnStops] }}
                                            </span>
                                          </v-col>
                                        </v-row>

                                        <v-row v-if="stop.open" style="margin-top: 0">
                                          <v-col cols="12">
                                            <v-card>
                                              <v-card-text class="p-5">
                                                <v-row style="margin: 0">
                                                  <v-col
                                                    class="title-table"
                                                    cols="12"
                                                    md
                                                    v-for="column in columnsDeliveriesOptions"
                                                    :key="column.text"
                                                    >{{ column.text }}</v-col
                                                  >
                                                </v-row>
                                                <template v-for="(deliveries, deliveriesIndex) in stop.children">
                                                  <div :key="deliveries.data.id">
                                                    <v-row
                                                      class="text-table"
                                                      :class="deliveriesIndex % 2 !== 0 ? 'off' : ''"
                                                    >
                                                      <v-col
                                                        class="no-padding"
                                                        v-for="(
                                                          columnDeliveries, columnDeliveriesIndex
                                                        ) in columnsDeliveries"
                                                        :key="columnDeliveries.text"
                                                        cols="12"
                                                        md
                                                      >
                                                        <span
                                                          v-if="columnDeliveriesIndex === 0"
                                                          @click="onExpandNormal(deliveries, node.key)"
                                                        >
                                                          <v-icon v-if="deliveries.open"> mdi-chevron-down </v-icon>
                                                          <v-icon v-else> mdi-chevron-right </v-icon>
                                                        </span>

                                                        <span>
                                                          {{ deliveries.data[columnDeliveries] }}
                                                        </span>
                                                      </v-col>
                                                    </v-row>

                                                    <v-row v-if="deliveries.open" style="margin-top: 0">
                                                      <v-col cols="12">
                                                        <v-card>
                                                          <v-card-text class="p-5">
                                                            <v-row style="margin: 0">
                                                              <v-col
                                                                class="title-table"
                                                                cols="12"
                                                                md
                                                                v-for="column in columnsNfeOptions"
                                                                :key="column.text"
                                                                >{{ column.text }}</v-col
                                                              >
                                                            </v-row>
                                                            <template v-for="(nfe, nfeIndex) in deliveries.children">
                                                              <div :key="nfe.data.accessKey">
                                                                <v-row
                                                                  class="text-table"
                                                                  :class="nfeIndex % 2 !== 0 ? 'off' : ''"
                                                                >
                                                                  <v-col
                                                                    class="no-padding"
                                                                    v-for="columnNfe in columnsNfe"
                                                                    :key="columnNfe + 'nfe'"
                                                                    cols="12"
                                                                    md
                                                                  >
                                                                    <div v-if="columnNfe === 'actions'">
                                                                      <v-menu offset-y>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                          <v-icon
                                                                            style="
                                                                              font-size: 36px;
                                                                              position: relative;
                                                                              top: -6px;
                                                                            "
                                                                            color="black"
                                                                            dense
                                                                            large
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                          >
                                                                            mdi-menu
                                                                          </v-icon>
                                                                        </template>
                                                                        <v-list>
                                                                          <v-list-item
                                                                            v-for="(
                                                                              item, indexDropdownNfe
                                                                            ) in itemsDropdownNfe"
                                                                            :key="indexDropdownNfe"
                                                                            @click="
                                                                              actionsDropdownNfe(indexDropdownNfe)
                                                                            "
                                                                          >
                                                                            <v-list-item-title>{{
                                                                              item.title
                                                                            }}</v-list-item-title>
                                                                          </v-list-item>
                                                                        </v-list>
                                                                      </v-menu>

                                                                      <MoreSVG
                                                                        class="ml-3"
                                                                        role="button"
                                                                        @click="openImportVolume()"
                                                                      />
                                                                    </div>
                                                                    <span v-else>
                                                                      <span>
                                                                        {{ nfe.data[columnNfe] }}
                                                                      </span>
                                                                    </span>
                                                                  </v-col>
                                                                </v-row>
                                                              </div>
                                                            </template>
                                                          </v-card-text>
                                                        </v-card>
                                                        <div class="mt20"></div>
                                                      </v-col>
                                                    </v-row>
                                                  </div>
                                                </template>
                                              </v-card-text>
                                            </v-card>
                                            <div class="mt20"></div>
                                          </v-col>
                                        </v-row>
                                      </div>
                                    </template>
                                  </v-card-text>
                                </v-card>
                                <div class="mt20"></div>
                              </v-col>
                            </v-row>
                          </div>
                        </template>
                      </v-card-text>
                    </v-card>
                    <div class="mt20"></div>
                  </v-col>
                </v-row>
              </div>
            </template>
            <div class="mt50"></div>
          </section>
          <section
            v-if="isProcessing"
            v-show="tabProcessing === 3 && !itemImportStatusProcessing && !itemImportStatusError"
            class="px-1"
          >
            <advance-form :forecastPayment.sync="forecastPayment" :advanceAmount.sync="advanceAmount" class="mb-6" />
            <div class="text-left">
              <h1 class="mt-8 mb-4">Descrição dos Adicionais</h1>
              <a href="#/financial/aditionals" target="_blank"> Clique aqui para incluir novos adicionais </a>
              <v-row dense class="my-4">
                <v-col>
                  <related-aditionals-panel
                    credits-only
                    :applicationUserId="userId"
                    v-model="relatedAditionals"
                    :aditionalRelated="additionalsDto"
                    @clickAddAditionals="onClickAddRelatedAditional"
                  />
                </v-col>
              </v-row>
              <aditionals-form v-model="additionalsDto" @relatedAditionalRemove="onRelatedAditionalRemove" credits-only>
              </aditionals-form>
            </div>
          </section>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="mt60"></div>
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import RelatedAditionalsPanel from '@/components/AccountsPayable/RelatedAditionalsPanel.vue';
const currencyMask = createNumberMask({
  prefix: '',
  thousandsSeparatorSymbol: '.'
});

import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import MessagesError from '../../../components/MessagesError.vue';
import t1 from '../../../assets/img/t1.png';
import t2 from '../../../assets/img/t2.png';
import t3 from '../../../assets/img/t3.png';
import t4 from '../../../assets/img/t4.png';
import t5 from '../../../assets/img/t5.png';

import BreadCrumb from '../../../components/BreadCrumb.vue';
import ShipmentImportFilters from '../../../components/Shipment/ShipmentImportFilters.vue';
import { XlsxRead, XlsxTable } from '../../../../node_modules/vue-xlsx/dist/vue-xlsx.es.js';
import AditionalsForm from '@/components/AditionalsForm.vue';
import AdvanceForm from '@/components/AdvanceForm.vue';

import maskCPF from '../../../utils/maskCPF';
import maskCNPJ from '../../../utils/maskCNPJ';
import maskData from '../../../utils/maskData';
import maskPrice from '../../../utils/maskPrice';
import removeCaracters from '../../../utils/removeCaracters';
import { VMoney } from 'v-money';
import { stringToMoneyMask } from '@/handlers/MoneyHandler.js';

// SVGs
import ViewSVG from '../../../assets/img/view.svg';

export default {
  name: 'Shipments',
  components: {
    XlsxRead,
    XlsxTable,
    BreadCrumb,
    ViewSVG,
    MessagesError,
    ShipmentImportFilters,
    AditionalsForm,
    AdvanceForm,
    RelatedAditionalsPanel
  },
  directives: { money: VMoney },
  data: () => ({
    forecastPayment: null,
    advanceAmount: null,
    additionalsDto: [],
    relatedAditionals: [],
    teste: [],
    userId: null,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    columnsTranshipment: ['type', 'name'],
    columnsTranshipmentOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'name',
        text: 'Nome'
      }
    ],
    columnsCargo: ['type', 'boardingNumber'],
    columnsCargoOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'boardingNumber',
        text: 'N° Embarque Externo'
      }
    ],
    columns: ['type', 'cityName', 'recipientCpfOrCnpj', 'recipientName', 'transhipmentPrice'],
    columnOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'cityName',
        text: 'Município'
      },
      {
        value: 'recipientCpfOrCnpj',
        text: 'CPF/CNPJ Destinatário'
      },
      {
        value: 'recipientName',
        text: 'Nome do Destinatário'
      },
      {
        value: 'transhipmentPrice',
        text: 'Preço do Transbordo'
      },
      {
        value: 'authorizationDate',
        text: 'Data de Autorização'
      },
      {
        value: 'costFreight',
        text: 'Preço do Frete'
      },
      {
        value: 'deliveryForecast',
        text: 'Previsão de Entrega'
      },
      {
        value: 'emissionDate',
        text: 'Data de Emissão'
      },
      {
        value: 'senderName',
        text: 'Enviado por'
      },
      {
        value: 'price',
        text: 'Preço'
      },
      {
        value: 'weight',
        text: 'Peso'
      }
    ],
    maskNumber: currencyMask,
    t1: t1,
    t2: t2,
    t3: t3,
    t4: t4,
    t5: t5,
    columnsStops: ['type', 'cityName', 'stateName', 'street', 'cpfOrCnpj', 'transhipmentPrice'],
    columnsStopOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'cityName',
        text: 'Cidade'
      },
      { value: 'stateName', text: 'Estado' },
      { value: 'street', text: 'Rua' },
      { value: 'cpfOrCnpj', text: 'CPF/CNPJ' },
      {
        value: 'transhipmentPrice',
        text: 'Preço do Transbordo'
      }
    ],
    columnsDeliveries: ['type', 'cte_authorizationDate', 'cte_costFreight', 'cte_emissionDate', 'deliveryForecast'],
    columnsDeliveriesOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'cte_authorizationDate',
        text: 'Data da Autorização'
      },
      { value: 'cte_costFreight', text: 'Preço do Frete' },
      { value: 'cte_emissionDate', text: 'Data da Emissão' },
      {
        value: 'deliveryForecast',
        text: 'Previsão de Entrega'
      }
    ],
    columnsNfe: ['type', 'price', 'weight'],
    columnsNfeOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      { value: 'price', text: 'Preço da NF', expander: false, show: true },
      { value: 'weight', text: 'Peso da NF', expander: false, show: true }
    ],
    errors: [],
    error500: null,
    errorsType: 'error',
    itemProcessing: [],
    loadingShipment: false,
    columnsDirect: [
      {
        field: 'type',
        header: 'Tipo',
        expander: true
      },
      { field: 'cityName', header: 'Cidade', expander: false },
      { field: 'stateName', header: 'Estado', expander: false },
      { field: 'street', header: 'Rua', expander: false },
      { field: 'cpfOrCnpj', header: 'CPF/CNPJ', expander: false },
      {
        field: 'cte_accessKey',
        header: 'CTE Chave de Acesso',
        expander: false
      },
      {
        field: 'cte_authorizationDate',
        header: 'Data da Autorização',
        expander: false
      },
      { field: 'cte_costFreight', header: 'Preço do Frete', expander: false },
      { field: 'cte_emissionDate', header: 'Data da Emissão', expander: false },
      {
        field: 'deliverer_document',
        header: 'Recipiente CPF/CNPJ',
        expander: false
      },
      { field: 'deliverer_name', header: 'Nome Recipiente', expander: false },
      {
        field: 'nfe_accessKey',
        header: 'NF-e Chave de Acesso',
        expander: false
      },
      { field: 'nfe_price', header: 'NF-e Preço', expander: false },
      { field: 'number', header: 'N°', expander: false }
    ],
    nodes: [],
    nodesDirect: [],
    expandedKeys: {},
    dateCreate: new Date().toLocaleDateString(),
    totalMileage: null,
    freightPrice: null,
    vehiclePlate: null,
    tab: null,
    items: ['DADOS GERAIS', 'DADOS DA PLANILHA'],
    tabProcessing: null,
    shipmentSelected: null,
    responsibleSelected: null,
    directDelivererId: null,
    directDelivererIdFilter: null,
    activePicker: null,
    loadingCreate: false,
    statusSelected: null,
    date: null,
    menu: false,
    file: null,
    filesDialog: false,
    validSheet: false,
    isProcessing: false,
    dates: '',
    loading: true,
    loadingSheet: false,
    dialogTrash: false,
    trashItem: {},
    dialogStatus: false,
    statusItem: {},
    itemImportStatusProcessing: false,
    itemImportStatusError: false,
    statusShipment: [],
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Embarques',
        disabled: false,
        to: '/shipments',
        exact: true
      },
      {
        text: 'Fiscal',
        disabled: true
      },
      {
        text: 'Importar Dados',
        disabled: true
      }
    ],
    headers: [
      { text: 'NOME DO ARQUIVO', value: 'fileName', align: 'start' },
      { text: 'IMPORTADO POR', value: 'responsibleUserName' },
      { text: 'DATA', value: 'createdAt' },
      { text: 'MOTORISTA', value: 'directDelivererName' },
      { text: 'STATUS', value: 'status' },
      { text: 'ID DO EMBARQUE', value: 'boardingId' },
      { text: 'AÇÕES', value: 'actions' }
    ],
    idBoardingSelected: null,
    transfer: 0,
    loads: 0,
    stops: 0,
    deliveries: 0,
    nfe: 0
  }),
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'DAY'));
    },
    isProcessing: {
      handler(value) {
        this.itemProcessing = null;
        if (value) {
          this.transfer = 0;
          this.loads = 0;
          this.stops = 0;
          this.deliveries = 0;
          this.nfe = 0;
          this.forecastPayment = null;
          this.advanceAmount = null;
          this.additionalsDto = [];
        }
      }
    }
  },
  computed: {
    ...mapState('ShipmentStore', ['paginate']),
    ...mapGetters('ShipmentStore', ['getShipments']),
    ...mapGetters('CouriersStore', ['getSummaryData']),
    ...mapGetters('UserStore', ['getUsers']),

    itemsProcessing() {
      let withProcessing = ['DADOS GERAIS'];

      if (!this.itemImportStatusError) {
        withProcessing.push('ENTREGA DIRETA');

        if (!this.itemImportStatusProcessing) {
          withProcessing.push('TRANSFERÊNCIAS');
        }
      } else {
        withProcessing.push('ERROS');
      }

      return withProcessing;
    },
    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);

        this.fetchAllShipment();
      }
    },
    shouldDisableImportButton() {
      const hasAdvance = this.advanceAmount ? Number(this.transformPriceToSend(this.advanceAmount)) > 0 : null;
      const hasForecastPayment = this.forecastPayment !== null;
      if (hasAdvance && hasForecastPayment) return false;
      else if (!hasAdvance && !hasForecastPayment) return false;
      else if (!hasAdvance && hasForecastPayment) return true;
      else return true;
    },
    formattedCreatedAt() {
      const createdAt = this.itemProcessing.createdAt;
      if (createdAt) {
        const dateObj = new Date(createdAt);
        const formattedDate = dateObj.toLocaleDateString('pt-BR');
        return formattedDate;
      } else {
        return '';
      }
    },
    hasValidFinancialData() {
      const hasAdvance = this.advanceAmount ? Number(this.transformPriceToSend(this.advanceAmount)) > 0 : false;
      const hasAdditionals = this.additionalsDto.length > 0;
      const hasPaymentForecast = this.forecastPayment !== null;

      if (!hasAdvance && !hasAdditionals && !hasPaymentForecast) return true;
      else if (hasPaymentForecast && hasAdvance && hasAdditionals) return true;
      else if (hasPaymentForecast && hasAdvance) return true;
      else return false;
    },
    hasRelatedAditional() {
      return this.relatedAditionals.length ? true : false;
    },
    hasRelatedAditionalsAdded() {
      return this.additionalsDto.some((aditional) => aditional.isRelatedAditional);
    }
  },

  mounted() {
    this.setItemPerPage(10);
    this.fetchAllShipment();
    this.fetchAllSummaryData();
    this.fetchAllUsers();
    this.fetchAllStatusShipment();
  },
  methods: {
    ...mapActions('UserStore', ['fetchUsers']),
    ...mapActions('ShipmentStore', [
      'fetchShipment',
      'toogleShipment',
      'approveShipmentSheet',
      'discartShipmentSheet',
      'createShipment',
      'fetchShipmentByID',
      'fetchStatusShipment'
    ]),
    ...mapActions('CouriersStore', ['fetchSummaryData']),
    ...mapMutations('ShipmentStore', [
      'setItemPerPage',
      'setPageNumber',
      'setFilterCreatedAt',
      'setFilterDirectDelivererName',
      'setFilterStatusId',
      'setFilterResponsibleUserName'
    ]),

    onClickAddRelatedAditional(relatedAditionals) {
      this.additionalsDto = [...this.additionalsDto, ...relatedAditionals];
    },

    onRelatedAditionalRemove(relatedAditional) {
      this.relatedAditionals = [...this.relatedAditionals, relatedAditional];
    },

    transformPriceToSend(element) {
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return money;
    },
    transformDate(date) {
      return maskData(date);
    },
    transformImportDate(date) {
      let dateObj = new Date(`${date}`);
      return `${dateObj.toLocaleDateString('pt-BR')} ${dateObj.toLocaleTimeString('pt-BR')}`;
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    },
    async fetchAllStatusShipment() {
      this.loading = true;

      try {
        const data = await this.fetchStatusShipment();

        this.statusShipment = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchAllUsers() {
      this.loading = true;

      try {
        await this.fetchUsers();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    checkValidSheetForm() {
      if (this.directDelivererId === '' || this.freightPrice === '' || this.totalMileage === '') {
        return false;
      } else {
        return true;
      }
    },
    async sendSheed() {
      if (this.directDelivererId === null || this.freightPrice === '' || this.totalMileage === '') {
        this.errorsType = 'info';
        this.errors = ['Campos obrigatórios precisam ser preenchidos.'];
        return;
      }
      const params = {
        directDelivererId: this.directDelivererId,
        freightPrice: Number(this.transformPriceToSend(this.freightPrice)),
        totalMileage: Number(removeCaracters(this.totalMileage))
      };

      let newFormData = new FormData();

      newFormData.append('boardingImportVM', JSON.stringify({ ...params }));
      newFormData.append('spreadsheet', this.file);

      this.loadingCreate = true;
      try {
        await this.createShipment(newFormData);

        this.fetchAllShipment();
        this.errorsType = 'success';
        this.errors = ['Upload feito com sucesso!'];
        this.validSheet = false;
      } catch (e) {
        console.error(e);
        this.errorsType = 'error';
        this.errors = ['Opss, algo deu errado no upload!'];
        this.error500 = e;
      } finally {
        this.loadingCreate = false;
      }
    },
    selectedDeliverer(item) {
      const summaryDataSelected = this.getSummaryData.filter(({ id }) => id === item);

      this.vehiclePlate = summaryDataSelected[0].plate;
    },
    closeAndOpen() {
      this.filesDialog = false;
      this.validSheet = true;
    },
    save(date) {
      this.$refs.menu.save(date);

      const partOfDate = date.split('-');
      const newDate = new Date(partOfDate[0], partOfDate[1] - 1, partOfDate[2]);

      this.setFilterCreatedAt(newDate.toISOString());

      this.fetchAllShipment();
    },
    onChange(file) {
      this.file = file || null;
    },
    async fetchAllSummaryData() {
      this.loading = true;
      try {
        await this.fetchSummaryData();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchAllShipment() {
      this.loading = true;
      try {
        await this.fetchShipment();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    openDialogTrash(item, index) {
      this.dialogTrash = true;
      this.trashItem = {
        ...item,
        index
      };
    },
    openDialogStatus(item, index) {
      this.dialogStatus = true;
      this.statusItem = {
        ...item,
        index
      };
    },
    changeItemsPerPage(items) {
      this.setItemPerPage(items);

      this.fetchAllShipment();
    },
    openProcessing(item) {
      this.itemImportStatusProcessing = item.status === 'Processando';
      this.itemImportStatusError = item.status === 'Erro no processamento';
      this.isProcessing = true;

      this.idBoardingSelected = item.id;
      this.fetchShipmentID(item.id);
    },
    onExpand(item) {
      if (item.data.type === 'Parada') {
        const stopIndex = item.key.split('-')[1];
        this.nodesDirect[stopIndex].open = !this.nodesDirect[stopIndex].open;
      }
      if (item.data.type === 'Entrega') {
        const stopIndex = item.key.split('-')[1];
        const deliveryIndex = item.key.split('-')[2];
        this.nodesDirect[stopIndex].children[deliveryIndex].open =
          !this.nodesDirect[stopIndex].children[deliveryIndex].open;
      }
    },
    onExpandNormal(item, nodeKey) {
      if (item.data.type === 'Transbordo') {
        this.nodes[nodeKey].open = !this.nodes[nodeKey].open;
      } else if (item.data.type === 'Carga') {
        const cargaNode = this.nodes[nodeKey]?.children.find((car) => car.key === item.key);
        cargaNode.open = !cargaNode.open;
      } else if (item.data.type === 'Parada') {
        const cargoIndex = item.key.split('-')[0];
        const stopIndex = item.key.split('-')[1];
        const stopNode = this.nodes[nodeKey]?.children.find((car) => car.key == cargoIndex).children[stopIndex];
        stopNode.open = !stopNode.open;
      } else if (item.data.type === 'Entrega') {
        const cargoIndex = item.key.split('-')[0];
        const stopIndex = item.key.split('-')[1];
        const deliveryIndex = item.key.split('-')[2];
        const deliveryNode = this.nodes[nodeKey]?.children.find((car) => car.key == cargoIndex).children[stopIndex]
          .children[deliveryIndex];
        deliveryNode.open = !deliveryNode.open;
      }
    },
    filterSearch() {
      this.setPageNumber(1);
      this.fetchAllShipment();
    },
    async fetchShipmentID(id) {
      this.loadingShipment = true;

      try {
        const dados = await this.fetchShipmentByID(id);
        const { userId } = dados;
        this.userId = userId;

        if (dados.dataJson) {
          const newCargo = dados.dataJson.cargos.map((item, index) => {
            const stops = item.stops.map((itemStop, indexStop) => {
              const newDeliverer = itemStop.deliveries.map((itemDeliverer, indexDeliverer) => {
                const newNfe = itemStop.deliveries[0].nfes.map((itemNfe, indexNfe) => {
                  return {
                    key: index + '-' + indexStop + '-' + indexDeliverer + '-' + indexNfe,
                    data: {
                      ...itemNfe,
                      nfe_accessKey: itemNfe.accessKey,
                      nfe_price: this.transformPrice(itemNfe.price),
                      type: 'Nota Fical'
                    }
                  };
                });

                return {
                  key: index + '-' + indexStop + '-' + indexDeliverer,
                  data: {
                    ...itemDeliverer,
                    deliverer_name: indexDeliverer.sender,
                    cte_accessKey: itemDeliverer.cte.accessKey,
                    deliveryForecast: this.transformDate(itemDeliverer.deliveryForecast),
                    cte_authorizationDate: this.transformDate(itemDeliverer.cte.authorizationDate),
                    cte_costFreight: itemDeliverer.cte.costFreight,
                    cte_emissionDate: this.transformDate(itemDeliverer.cte.emissionDate),
                    cte_id: itemDeliverer.cte.id,
                    cte_number: itemDeliverer.cte.number,
                    type: 'Entrega'
                  },
                  children: newNfe,
                  open: false
                };
              });

              const newStop = {
                key: index + '-' + indexStop,
                data: {
                  ...itemStop,
                  ...itemStop.recipient,
                  ...itemStop.recipient.address,
                  type: 'Parada',
                  cpfOrCnpj: this.transformCpfOrCnpj(itemStop.recipient.cpfOrCnpj),
                  transhipmentPrice: this.transformPrice(itemStop.transhipmentPrice || 0)
                },
                children: newDeliverer,
                open: false
              };

              return newStop;
            });

            const newItem = {
              key: index,
              data: {
                ...item,
                type: 'Carga'
              },
              children: stops,
              open: false
            };
            return newItem;
          });

          const newNodesDirects = newCargo.filter((item) => {
            return item.data.isDirectDelivery;
          });

          const newNodes = newCargo.filter((item) => {
            return item.data.isDirectDelivery === false;
          });

          let nodesDirectsNew = [];

          newNodesDirects.map((item) => {
            return nodesDirectsNew.push(...item.children);
          });

          const nodesDirect = nodesDirectsNew.map((item) => {
            const childrens = item.children.map((itemChildren) => {
              const itensChildren = {
                children: itemChildren.children,
                data: {
                  ...itemChildren.data
                },
                key: itemChildren.key,
                open: false
              };

              const itensChildrens = itensChildren.children.map((itemNFe) => {
                const nfeChildren = {
                  data: {
                    ...itemNFe.data
                  },
                  key: itemNFe.key
                };

                return nfeChildren;
              });

              return {
                key: itensChildren.key,
                children: itensChildrens,
                data: itensChildren.data,
                open: false
              };
            });

            return {
              key: item.key,
              children: childrens,
              data: item.data,
              open: false
            };
          });

          this.nodesDirect = nodesDirect;
          this.nodes = newNodes;

          let transhipmentNameList = [];

          const resultTransfer = newNodes.reduce(
            (acc, current) => {
              const has = acc[0].some((ele) => ele.data.transhipmentName === current.data.transhipmentName);
              if (has) {
                const _has = acc[1].some((ele) => {
                  ele.data.transhipmentName === current.data.transhipmentName;
                });
                if (!_has) {
                  acc[1] = [...acc[1], current];
                }
              } else {
                acc[0] = [...acc[0], current];
              }
              if (!transhipmentNameList.includes(current.data.transhipmentName)) {
                transhipmentNameList.push(current.data.transhipmentName);
              }
              return acc;
            },
            [[], []]
          );

          let transhipments = [];
          transhipmentNameList.map((item, index) => {
            const t = {
              key: index,
              data: { name: item, type: 'Transbordo' },
              children: [],
              open: false
            };
            this.nodes.map((node) => {
              if (node.data.transhipmentName === item) {
                t.children.push(node);
              }
            });
            transhipments.push(t);
          });

          this.nodes = transhipments;

          this.transfer = resultTransfer[0].length;

          this.loads = dados.dataJson.cargos.length;

          dados.dataJson.cargos.map((item) => {
            this.stops = this.stops + item.stops.length;

            item.stops.map((itemStops) => {
              this.deliveries = this.deliveries + itemStops.deliveries.length;

              itemStops.deliveries.map((itemDeliverer) => {
                this.nfe = this.nfe + itemDeliverer.nfes.length;
              });
            });
          });
        }
        this.itemProcessing = { ...dados, freightPrice: stringToMoneyMask(dados.freightPrice) };
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingShipment = false;
      }
    },
    transformMoney(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return Number(money);
    },
    isDetailsValid(status) {
      const invalidStatuses = ['Descartada', 'Processando', 'Concluído'];
      return !invalidStatuses.includes(status);
    },
    async approveSheet(bool = true) {
      this.loadingCreate = true;
      try {
        if (bool) {
          const data = await this.approveShipmentSheet({
            id: this.idBoardingSelected,
            advanceAmount: Number(this.transformPriceToSend(this.advanceAmount)),
            forecastPayment: this.forecastPayment,
            additionalsDto: this.additionalsDto
          });
          this.handleFeedback(data, true);
        } else {
          const data = await this.discartShipmentSheet({ id: this.idBoardingSelected });
          this.handleFeedback(data, false);
        }
        this.fetchAllShipment();
      } catch (err) {
        console.error(err);
        this.errorsType = 'error';
        this.errors = ['Opss, algo deu errado!'];
      } finally {
        this.loadingCreate = false;
      }
    },
    handleFeedback(data, isApprove) {
      if (data.success) {
        this.errorsType = 'success';
        this.isProcessing = false;
        if (isApprove) {
          this.errors = ['Planilha aprovada com sucessso!'];
        } else {
          this.errors = ['Planilha desaprovada com sucessso!'];
        }
      } else {
        this.errorsType = 'error';
        this.errors = data.errors;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-file-input__text {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  top: -6px !important;
  position: relative !important;
  left: 145px !important;
  width: auto !important;
}

.p-treetable table {
  min-width: 100%;
  width: auto;
}

.p-treetable-tbody,
.p-treetable-thead {
  span {
    padding-left: 30px;
    white-space: nowrap;
  }
}

.close-right {
  position: absolute;
  right: 30px;
  top: 30px;
}
</style>
